export default "__VITE_ASSET__6b970077__"